<template>
  <div>
    <FullCalendar
      :locale="locale"
      :plugins="calendarOptions.plugins"
      :header="calendarOptions.headerToolbar"
      allDayDefault="true"
      defaultView="dayGridMonth"
      @dateClick="dateClick"
      @eventClick="eventClick"
      :event-sources="eventSources"
    />

    <v-dialog ref="dialog" v-model="showDialog" max-width="600px">
      <edit-form
        :model="$store.getters['modelEvent']"
        :rawValues="dialogInitialData"
        :key="redrawDialog"
        hide-back-btn
        @close="showDialog = false"
        @submit="saveEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import EditForm from "./Form";
import ruLocale from '@fullcalendar/core/locales/ru';

export default {
  components: {
    FullCalendar,
    EditForm
  },
  data() {
    return {
      colors: ["blue", "indigo", "deep-purple"],
      locale: ruLocale,
      calendarOptions: {
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin // needed for dateClick
          ],
          headerToolbar: {
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay'
          }, 
      },
      showDialog: false,
      dialogInitialData: {},
      redrawDialog: 0,
      dialogId: null,
      
    }
  },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    eventSources: function(){ 
      let self = this;
      return [
        {
          events(data, cb) {
            //self.$store.dispatch('findEventtype').then(() => {
              cb(self.events.map(event => {
                return {
                  id: event.id,
                  title: self.$store.getters['listEventtype'].find(el => el.id === event.eventType).name,
                  start: new Date(event.dateStart),
                  end: new Date(event.dateEnd),
                  color: self.colors[event.eventType.id - 1],
                  textColor: "#fff",
                  allDay: (event.dateEnd-event.dateStart > 10*60*60*1000)
                }
              }))
            //})
          }
        },
        {
          events(date, cb) {
            let periodStart = date.start.getTime()//new Date(start.start).getTime();
            let periodEnd = date.end.getTime()//new Date(endStr).getTime()
            let params = {
              where: {
                dateStart: { '<':  periodEnd},
                dateEnd:   { '>': periodStart},
              },
              limit: 1000,
              skip: 0,
              parentEntityName: 'dress',
              parentEntityId: self.dress
            }

            if (self.events.length) {
              cb([])
            } else {
              self.$store.dispatch('findEvent', params).then(resp => {
                cb(
                  resp.data.map(event => {
                    return {
                      id: event.id,
                      title: event.client.name || event.eventType.name,
                      start: new Date(event.dateStart),
                      end: new Date(event.dateEnd),
                      color: self.colors[event.eventType.id - 1],
                      textColor: "#fff",
                      allDay: (event.dateEnd-event.dateStart > 10*60*60*1000)
                    }
                  })
                )
              })
            }
          }
        }
      ]}
  },
  methods: {
    dateClick: function(info) {
      let offset = new Date().getTimezoneOffset() * 60 * 1000;
      this.dialogInitialData = {};
      // c 12 утра первого дня
      this.dialogInitialData.dateStart = info.date.getTime() - offset + 12 * 60 * 60 * 1000;
      // до 21 часа последнего дня
      this.dialogInitialData.dateEnd =
        info.date.getTime() - offset + 24 * 60 * 60 * 1000 * 2 + 21 * 60 * 60 * 1000; //+ 3 дня
      this.dialogInitialData.dress = [this.$store.getters.oneDress] || [];
      this.redrawDialog += 1;
      this.dialogId = null;
      this.showDialog = true;
    },
    eventClick: function(data) {
      this.$store.dispatch("findOneEvent", data.event.id).then(() => {
        this.dialogId = data.event.id;
        this.redrawDialog += 1;
        this.showDialog = true;
        this.dialogInitialData = this.$store.getters.oneEvent;
      });
    },
    saveEvent: function(data) {
      this.dialogId ? this.updateEvent(data) : this.createEvent(data);
    },
    createEvent: function(data) {
      this.$store.dispatch("createEvent", data).then(resp => {
        this.showDialog = false;
        this.events.push(resp.data);
      });
    },
    updateEvent: function(data) {
      this.$store
        .dispatch("updateEvent", {
          id: this.dialogId,
          data: data
        })
        .then(() => {
          this.showDialog = false;
          this.$emit("refreshEvents");
        });
    }
  },
  mounted() {
    this.$store.dispatch("loadModelEvent");
    this.$store.dispatch('findEventtype');
  }
};
</script>

<style lang='scss'>

@import '~@fullcalendar/core/main.css';
@import '~@fullcalendar/daygrid/main.css';
@import '~@fullcalendar/timegrid/main.css';

</style>